import { makeStyles, styled } from '@material-ui/core/styles'
import { Link as MuiLink, Container } from '@material-ui/core'

const drawerWidth = 95
const drawerMobileWidth = 220

export const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    '& .MuiButton-containedPrimary': {
      color: theme.palette.primary.contrastText,
      fontWeight: 600,
    },
    '& .MuiTab-textColorInherit.Mui-selected': {
      fontWeight: 600,
    },
  },
  helpIcon: {
    margin: '0 10px',
    fill: theme.sidebar.color,
    cursor: 'pointer',
  },
  ToolbarNav: {
    minHeight: '80px',
  },
  trialText: {
    fontSize: '13px',
    lineHeight: '32px',
    color: theme.header.topbar.color,
    fontWeight: 500,
    '& .MuiLink-root': {
      color: theme.header.topbar.link,
    },
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    backgroundColor: theme.header.background,
    boxShadow: '14px 5px 35px 0 rgba(0,0,0,0.08)',
  },

  userDropdown: {
    margin: '10px 0',
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },

  topNavBar: {
    display: 'flex',
    alignItems: 'center',
  },
  drawerPaper: {
    width: drawerWidth,
    top: '80px !important',
    background: theme.sidebar.background,
  },

  drawerMobilePaper: {
    width: drawerMobileWidth,
    marginTop: '0',
    background: theme.sidebar.background,
    '& .MuiIconButton-root': {
      padding: theme.spacing(2.1),
    },
  },
  hide: {
    display: 'none',
  },
  drawerContainer: {
    overflow: 'auto',
  },
  content: {
    flexGrow: 1,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    paddingTop: '6.5rem',
    width: 1,
    margin: '0 auto',
  },
  marginLeftAuto: {
    justifyContent: 'end',
    display: 'flex',
    alignItems: 'center',
  },
  SettingNavBarDropdown: {
    padding: '0 0 0 20px',
    '& .MuiAvatar-root': {
      height: '36px',
      width: '36px',
      background: theme.header.avatar,
    },
    '& .MuiButton-root:hover, & .MuiButton-root:active, & .MuiButton-root:focus':
      {
        background: 'transparent',
      },
  },
  borderRight: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRight: '1px solid #EDEDED',
    '& .MuiFormControl-root': {
      margin: '0',
    },
    '& .MuiButton-root:hover, & .MuiButton-root:active, & .MuiButton-root:focus':
      {
        background: 'transparent',
      },
  },
  logo: {
    flexGrow: 1,
  },
  headTypography: {
    color: theme.header.topbar.color,
  },
  [theme.breakpoints.down('sm')]: {
    logo: {
      textAlign: 'center',
    },
    appBar: {
      zIndex: theme.zIndex.drawer + 1,
      backgroundColor: theme.header.background,
      transition: theme.transitions.create(['margin', 'width'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
    },
    appBarShift: {
      marginLeft: 0,
      transition: theme.transitions.create(['margin', 'width'], {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    content: {
      flexGrow: 1,
      padding: theme.spacing(3),
      transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      marginLeft: 0,
    },
    contentShift: {
      transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: 0,
    },
    trialText: {
      fontWeight: 600,
      padding: '10px 30px',
      lineHeight: '18px',
    },
    ToolbarNav: {
      minHeight: '64px',
    },
    borderRight: {
      borderWidth: '0',
      padding: '0',
    },
    DrawerMenuIcon: {
      width: '48px',
      height: '48px',
    },

    SettingNavBarDropdown: {
      padding: '0',
    },
    brand: {
      height: '36px',
      width: 'auto',
      maxWidth: '95%',
    },
  },
}))

export const LogoImage = styled('img')({
  height: '3rem',
})
